module.exports = __webpack_public_path__ + "static/media/screen4.bb088568.png";